import { POSTGRES_RUNTIME_DEP } from '@cli-constants/deps.js'
import { hasProjectDependency } from './has-project-dependency.js'

export function hasPostgresRuntimeDependency(cwd: string): boolean {
  return hasProjectDependency(cwd, POSTGRES_RUNTIME_DEP)
}
